import React, { useEffect, useState } from "react";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function TemplatesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/templates")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <MarketingLayout>
      <section className="max-w-7xl mx-auto px-6 py-16">
        <p className="text-xs uppercase tracking-wider font-semibold text-[#F58220]">Library</p>
        <h1 className="mt-2 text-4xl md:text-5xl font-extrabold tracking-tight text-[#1F3A6B]">Survey Templates</h1>
        <p className="mt-3 text-slate-600 text-lg max-w-2xl">Battle-tested templates built by CX experts. Use them as-is or customize in seconds.</p>
        {loading ? (
          <div className="mt-10 grid md:grid-cols-3 gap-5">
            {[...Array(6)].map((_, i) => <div key={i} className="h-40 bg-slate-100 rounded-xl animate-pulse"/>)}
          </div>
        ) : (
          <div className="mt-10 grid md:grid-cols-3 gap-5">
            {items.map((t) => (
              <Card key={t.id} data-testid={`tpl-card-${t.id}`} className="p-6 border-slate-100 hover:shadow-elev-2 transition-shadow flex flex-col">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-bold text-[#1F3A6B] text-lg leading-tight">{t.title}</h3>
                  <Badge variant="outline" className="text-[10px] uppercase tracking-wider bg-[#FFF0DF] text-[#F58220] border-[#FFE1BE]">{t.category}</Badge>
                </div>
                <p className="mt-2 text-sm text-slate-600">{t.description}</p>
                <div className="mt-4 text-xs text-slate-500">{t.questions?.length || 0} questions · Industry: {t.industry || "general"}</div>
                <div className="mt-auto pt-5">
                  <Link to="/signup"><Button data-testid={`tpl-use-${t.id}`} className="w-full bg-[#F58220] hover:bg-[#E36F0E] text-white">Use template</Button></Link>
                </div>
              </Card>
            ))}
          </div>
        )}
      </section>
    </MarketingLayout>
  );
}
